/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const PatientApi = {
  public: {},
  private: {
    /**
     *  Fetch patient info
     */
    fetchPatientInfo: ({ PatientID, MedicalGroupID }) => ProtectedHttpClient.post(`/patient`, { PatientID, MedicalGroupID }),
    /**
     * Fetch patient appointments
     */
    fetchPatientAppointments: ({ PatientID, POSPracticeID }) => ProtectedHttpClient.post(`/appts/1/patient/list`, { PatientID, POSPracticeID }),
    /**
     * Fetch patient invoices
     */
    fetchPatientInvoices: ({ PatientID, POSPracticeID }) => ProtectedHttpClient.post(`/invoice/patient/list`, { PatientID, POSPracticeID }),
    /**
     * Fetch patient groups
     */
    fetchPatientGroups: ({ PatientID, POSPracticeID }) => ProtectedHttpClient.post(`/staticgroup/patient/list`, { PatientID, POSPracticeID }),
    /**
     * Fetch patient guarantor
     */
    fetchPatientGuarantor: ({ PatientID, MedicalGroupID }) => ProtectedHttpClient.post(`/patient/guarantor`, { PatientID, MedicalGroupID }),
  },
};
export default PatientApi;
